import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { t } from 'ttag';

import { Modal, PINInput } from 'components';

function Validate({
  isOpen,
  onClose,
  OTP,
  setOTP,
  isValidatingCode,
  handleResendCode,
  handleCodeValidation,
  errorMessage
}) {
  const [resendCodeTimer, setResendCodeTimer] = useState(0);

  const handleResendCodeTimer = useCallback(() => {
    let timeLeft = 15;
    setResendCodeTimer(timeLeft);

    const countdown = () => {
      if (timeLeft < 0) {
        // eslint-disable-next-line no-use-before-define
        clearTimeout(timer);
      } else {
        timeLeft--;
        setResendCodeTimer(timeLeft);
      }
    };

    const timer = setInterval(countdown, 1000);
  }, []);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose()}
      title={t`We have sent you an email.`}
      maxWidth="md"
    >
      <p className="m-0 text-sm text-dark-gray">
        {t`Please enter your one-time password below to continue. If you do not receive an email within a few seconds, please check your spam folder.`}
      </p>
      <PINInput
        PIN={OTP}
        setPIN={setOTP}
        onFilled={code => handleCodeValidation(code)}
        disabled={isValidatingCode}
      />
      <button
        type="button"
        className="m-0 border-0 bg-transparent p-0 py-2 text-sm text-dark-gray disabled:opacity-50"
        tabIndex={-1}
        disabled={resendCodeTimer > 0}
        onClick={() => {
          handleResendCodeTimer();
          handleResendCode();
        }}
      >
        {t`Did you not receive an email?`}{' '}
        <span className="text-green underline">{t`Send a new one.`}</span>
      </button>
      {resendCodeTimer > 0 && (
        <p className="text-sm text-dark-gray">
          {t`We sent you another email! You can send another one in ${resendCodeTimer} seconds.`}
        </p>
      )}
      {errorMessage !== '' && (
        <p className="m-0 text-sm text-cinnebar">{errorMessage}</p>
      )}
    </Modal>
  );
}

Validate.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  isValidatingCode: PropTypes.bool,
  handleResendCode: PropTypes.func.isRequired,
  handleCodeValidation: PropTypes.func.isRequired,
  errorMessage: PropTypes.string
};

Validate.defaultProps = {
  isOpen: false,
  onClose: () => {},
  isValidatingCode: false,
  errorMessage: ''
};

export default Validate;
